<template>
  <div class="ProviderRecord">
    <div class="TopSearch">
      <FromComm :FromArr="FromArr"></FromComm>
      <div class="btngroup">
        <CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
      </div>
    </div>
    <div class="BottomTable">
      <!--   v-if="qx.enabled" v-if="qx.enabled" AddOptional-->
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" :optional="false" @btnclick="adduser" opwidth="71px" top="352px" :src="require('@/assets/icon/icon-add.png')">
      </Commonbtn>
      <Commonbtn  v-if="qx.update"  backgroundColor="#FFF" title="修改" fontSize="14px" :optional="updateOptional" :useAutoOptional="false" @btnclick="update" opwidth="71px" top="352px" :src="require('@/assets/icon/icon-update.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.del"  backgroundColor="#FFF" title="删除" fontSize="14px" :optional="DelOptional" @btnclick="del" opwidth="71px" top="352px" :src="require('@/assets/icon/icon-del.png')">
      </Commonbtn>
      <!-- <Commonbtn backgroundColor="#FFF" title="启用" fontSize="14px" @btnclick="Active" :src="require('@/assets/icon/qy.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" title="停用" fontSize="14px" @btnclick="DeActive" :src="require('@/assets/icon/icon-stop.png')">
      </Commonbtn> -->
      <!-- <CommonbtnUpLoad backgroundColor="#FFF" title="导入" fontSize="14px" @getFile="InvoiceImport" :src="require('@/assets/icon/icon-drjys.png')">
      </CommonbtnUpLoad> -->
      <Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="CRExport" :src="require('@/assets/icon/daoc.png')">
      </Commonbtn>
      <!-- <CommonbtnUpLoad backgroundColor="#FFF" types="multiple" title="上传照片" Submit fontSize="14px" @getFiles="UploadPhotos" :src="require('@/assets/icon/daoc.png')">
      </CommonbtnUpLoad> -->
      <Commonbtn v-if="qx.submit" backgroundColor="#FFF" title="提交" fontSize="14px" @btnclick="Submit" :optional="SubmitOptional" opwidth="70px" top="353px" :src="require('@/assets/channel/Submit.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.submit" backgroundColor="#FFF" title="撤回" :optional="WithdrawOptional" opwidth="71px" top="352px" fontSize="14px" @btnclick="withdraw" :src="require('@/assets/channel/withdraw.png')">
      </Commonbtn>
      <!-- <a class="Dowload" style="" @click="DsphfDowload">下载配送商医院备案导入模板</a> -->
      <div class="Table">
        <Commontable ref="ProviderRef" @cz="cz" @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" width="900px" colnum=522 :tableData="tableData" :headerData="headerData" height="100%">
        </Commontable>
        <div class="pagination">
          <Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
        </div>
      </div>
    </div>
    <DialogFrom width="1000px" title="新增配送商医院备案" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from" style="position: relative;overflow-y: scroll;height: 500px;">
        <template v-for="(item , index) of fromdataadd">
          <Commondropdownlist :key="index" ref="DsphFAddref" :event="item.event" :disabledHB="item.disabled" :selcoms="item.selcoms" :widths="item.widths" :loading="loading" @JXSChage="JXSChage" @remoteMethodtows="remoteMethodtows" @remoteMethodtowPer="remoteMethodtowPer" @remoteMethodtowHB="remoteMethodtowHB" @remoteHosType="remoteHosType" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
          </Commondropdownlist>
        </template>
        <CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple" style="height: 120px;display: inline-block;vertical-align: top;"></CommonUploadEnclosure>
        <div class="uploadImg">
          <div v-for="(item,index) of ImageUrl" :key="index+'update'" style=" display: inline-block;overflow: hidden;">
            <img src="@/assets/channel/firstbusiness/phontsDel.png" alt="" class="del_icon" @click="Delicon(index)">
            <img src="@/assets/channel/firstbusiness/phontsD.png" alt="" class="See_icon" @click="Seeicon(item)">
            <!-- ${ config.http_URL } + -->
            <img :src="` ${ item }`" alt="" class="imgBJ">
            <div class="DelOrSee"></div>
          </div>
        </div>
      </div>
    </DialogFrom>
    <DialogFrom width="1000px" title="修改配送商医院备案" :loading="loading" :dialogVisible="dialogVisiblesedit" @cancel="canceledit" @dialogOK="dialogOKedit">
      <div class="from" style="overflow-y: scroll;height: 500px;">
        <template v-for="(item , index) of fromdataedit">
          <Commondropdownlist ref="DsphFEditref" :event="item.event" @JXSUPChage="JXSUPChage" :selcoms="item.selcoms" :disabledHB="item.disabled" :disabled="item.disabled" :radio="item.radio" :key="index" :widths="item.widths" :options="item.options" @remoteMethodtows="remoteMethodtows" @remoteMethodtowPer="remoteMethodtowPer" @remoteMethodtowHB="remoteMethodtowHB" @remoteHosType="remoteHosType" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
          </Commondropdownlist>
        </template>
        <CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple" style="height: 120px;"></CommonUploadEnclosure>
        <div class="uploadImg">
          <div v-for="(item,index) of ImageUrl" :key="index+'update'" style=" display: inline-block;overflow: hidden;">
            <img src="@/assets/channel/firstbusiness/phontsDel.png" alt="" class="del_icon" @click="Delicon(index)">
            <img src="@/assets/channel/firstbusiness/phontsD.png" alt="" class="See_icon" @click="Seeicon(item)">
            <img :src="`${ item }`" alt="" class="imgBJ">
            <div class="DelOrSee"></div>
          </div>
        </div>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel" :src="require('@/assets/icon/icon-del2.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条数据吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate" @dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要启用这条档案吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleSubmit" @cancel="cancelSubmit" @dialogOK="dialogOKSubmit" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要提交这条数据吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblewithdraw" @cancel="cancelwithdraw" @dialogOK="dialogOKwithdraw" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要撤回这条数据吗？</span>
    </Dialog>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivateDe" @cancel="canceldeactivateDe" @dialogOK="dialogOKdeactivateDe" :src="require('@/assets/icon/icon-errors.png')">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条数据吗？</span>
    </Dialog>
    <DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg" @dialogOK="dialogOKdrjg">
      <div class="from">
        <Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
        </Commontable>
      </div>
    </DialogFrom>
    <Commonpictureswitching :show="show" @hidefn="hidefn" :picImages="picImages"></Commonpictureswitching>
    <Prviwe :show="shows" @hidefn="hidefns" :imgsrc="imgsrc"></Prviwe>
  </div>
</template>

<script>
import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '../../../../../../components/commongroup.vue'
import Commonbtn from '../../../../../../components/common-btn.vue'
import Commontable from '../../../../../../components/common-table.vue'
import Pagination from '../../../../../../components/pagination.vue'
import DialogFrom from '../../../../../../components/dialog-from.vue'
import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
import Dialog from '../../../../../../components/dialog.vue'
import utils from '../../../../../../common/utils'
import FromArr from './view/FromData/FromArr'
import fromdata from './view/FromData/add'
import fromdataedit from './view/FromData/edit'
import headerData from './view/TableData/headerData'
import Commonpictureswitching from '../../../../../../components/common-pictureswitching.vue'
import Prviwe from '../../../../../../components/picturepreview.vue'
import Commondropdownlist from '../../../../../../components/common-dropdownlist.vue'
import CommonUploadEnclosure from '../../../../../../components/common-upload-Enclosure.vue'
import {
  APPRelationProviderList,
  APPRelationProviderInfo,
  APPRelationProviderGetImages,
  APPRelationProviderExport,
  APPRelationProviderAdd,
  APPRelationProviderEdit,
  APPRelationProviderDelete,
  APPRelationProviderUploadImageByEdit,
  APPRelationProviderSubmit,
  APPRelationProviderRevoke,
} from '@/api/channel'
import {
  CusRelationProviderAdd,
  CusRelationProviderInfo,
  CusRelationProviderEdit,
  CusRelationProviderGetInvoicePic,
  CusRelationProviderDelete,
  CusRelationProviderActive,
  CusRelationProviderDeActive,
  CusRelationProviderImport,
  CusRelationProviderUploadSalesInvListPic,
  CusRelationProviderDownloadTemplet,
  CusRelationProviderUploadSalesInvListByEdit,
  HospitalGetHospitalType,
  InventoryClassList,
  CustomerList,
  HospitalList,
  HospitalInfo,
  CusRelationProviderExport,
} from '@/api/home'
export default {
  components: { FromComm, CommonBtngroup, Commonbtn, Commontable, Pagination, DialogFrom, CommonbtnUpLoad, Dialog, CommonUploadEnclosure, Commonpictureswitching, Prviwe, Commondropdownlist },
  props: {},
  data() {
    return {
      tableData: [],
      total: 1,
      pageindex: 1,
      pageSize: 10,
      showorhide: true,
      dialogVisibles: false,
      dialogVisiblesedit: false,
      dialogVisibledel: false,
      dialogVisibledeactivate: false,
      dialogVisibledeactivateDe: false,
      dialogVisiblewithdraw: false,
      dialogVisibleSubmit: false,
      rowboo: false,
      dialogVisiblesdrjg: false,
      rightboo: false,
      dwonleft: false,
      loading: false,
      show: false,
      shows: false,
      AddOptional: true,
      updateOptional: true,
      DelOptional: true,
      SubmitOptional: true,
      WithdrawOptional: true,
      title: "结果",
      ID: '',
      imgsrc: '',
      ptype: '',
      HPid: '',
      HospHPid: '',
      InvClassCode: '',
      InvClassCodeName: '',
      HPidName: '',
      HospHPidName: '',
      TXCusName: '',
      TXCusID: '',
      stateDelIcon: '',
      FileName: [],
      ImageUrl: [],
      fromdataadd: [],
      fromdataedit: [],
      handleList: [],
      tableDatadrjg: [],
      tableData: [],
      headerData: [],
      FromArr: [],
      picImages: [],
      from: {
        CusName: "",
        InvClass: "",
        ProviderName: "",
        ProviderType: "",
        HosType: "",
        HPName: "",
        HasHPInvoice: "",
        TXCusName: '',
        ActiveTime1: "",
        ActiveTime2: "",
        CreateTime1: "",
        CreateTime2: ""
      },
      qus: [],
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
        setting: false
      },
    }
  },
  created() {
    this.APPRelationProviderList()
    this.inventoryClassList()
  },
  mounted() {
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
    this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async APPRelationProviderList() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载列表中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        data,
        code
      } = await APPRelationProviderList({
        CusName: this.from.CusName,
        InvClass: this.from.InvClass,
        ProviderName: this.from.ProviderName,
        ProviderType: this.from.ProviderType,
        // HosType: this.from.HosType,
        TXCusName: this.from.TXCusName,
        HPName: this.from.HPName,
        HasHPInvoice: this.from.HasHPInvoice,
        ActiveTime1: this.from.ActiveTime1,
        ActiveTime2: this.from.ActiveTime2,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (code == 0) {
        this.total = data.Count
        this.tableData = data.data
      }
      loading.close();
    },
    // 导出
    async APPRelationProviderExport() {
      let resexprot = await APPRelationProviderExport({
        CusName: this.from.CusName,
        InvClass: this.from.InvClass,
        ProviderName: this.from.ProviderName,
        ProviderType: this.from.ProviderType,
        // HosType: this.from.HosType,
        TXCusName: this.from.TXCusName,
        HPName: this.from.HPName,
        HasHPInvoice: this.from.HasHPInvoice,
        ActiveTime1: this.from.ActiveTime1,
        ActiveTime2: this.from.ActiveTime2,
        CreateTime1: this.from.CreateTime1,
        CreateTime2: this.from.CreateTime2,
        pageSize: this.pageSize,
        pageIndex: this.pageindex
      })
      if (resexprot) {
        //console.log(resexprot);
        if (resexprot.code == 999) {
          this.$message({
            type: "warning",
            message: resexprot.message
          })
        }
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot.data, `经销商/服务商/医院备案${str}`, "xlsx")
      } else {
        // 返回json
        this.$message.warning('导出失败');
      }
    },
    CRExport() {
      this.APPRelationProviderExport()
    },
    async hospitalGetHospitalType() {
      let {
        data,
        code
      } = await HospitalGetHospitalType({
      })
      if (code == 0) {
        this.formdata[3].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Name,
            value: item.Name
          }
          this.formdata[3].options.push(obj)
        })
      }
    },
    // 查看图片
    async APPRelationProviderGetImages(id) {
      let {
        code,
        data
      } = await APPRelationProviderGetImages({
        ID: id
      })
      if (code == 0) {
        this.picImages = data.picImages
        this.show = true
      } else {
        this.$message.warning(message)
      }
    },
    cz(ID) {
      this.APPRelationProviderGetImages(ID)

    },
    hidefn() {
      this.show = false
    },
    hidefns() {
      this.shows = false
    },
    Delicon(index) {
      this.ImageUrl.splice(index, 1)
      if (this.stateDelIcon == 'update') {
        this.FileName.splice(index, 1)
        //console.log(this.FileName, 'FileName');
      }
    },
    Seeicon(URL) {
      this.shows = true
      this.imgsrc = URL
    },
    async remoteCustomer(val) {
      let {
        data,
        code
      } = await CustomerList({
        CusName: val,

      })
      if (code == 0) {
        this.InvClassCode = data.data[0].CusCode
      }
    },
    // 二级经销商下拉
    async remoteMethodtowPer(query) {
      this.loading = true
      let {
        data,
        code
      } = await CustomerList({
        CusName: query,

      })
      if (code == 0) {
        this.fromdataadd[1].options = []
        this.fromdataedit[1].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.CusCode,
            value: item.CusName
          }
          this.fromdataadd[1].options.push(obj)
          this.fromdataedit[1].options.push(obj)
        })
        this.loading = false
      }
    },
    async hospitalGetHospitalType() {
      let {
        data,
        code
      } = await HospitalGetHospitalType({
      })
      if (code == 0) {
        // this.fromdataadd[2].options = []
        // this.fromdataedit[2].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Name,
            value: item.Name
          }
          // this.fromdataadd[2].options.push(obj)
          // this.fromdataedit[2].options.push(obj)
        })
      }
    },
    // 详情
    async APPRelationProviderInfo() {
      const loading = this.$loading({
        lock: true,
        text: '正在加载详情中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message,
        data
      } = await APPRelationProviderInfo({
        ID: this.ID
      })
      if (code == 0) {
        this.fromdataedit[0].inputdata = data.InvClass
        this.fromdataedit[1].inputdata = data.CusName
        // this.fromdataedit[2].inputdata = data.ProviderType
        this.fromdataedit[2].inputdata = data.TXCusName
        this.fromdataedit[3].inputdata = data.ProviderName
        this.fromdataedit[4].inputdata = data.HPName
        this.fromdataedit[5].inputdata = data.VouchValiDate
        this.fromdataedit[7].inputdata = data.Remark
        this.fromdataedit[6].radio = data.HasHPInvoice + ""
        data.lstImages.map((item, index) => {
          this.ImageUrl.push(item.ImageUrlPath)
          this.FileName.push(item.ImagePath)
        })
        this.InvClassCodeName = data.CusName
        this.HPidName = data.ProviderName
        this.HospHPidName = data.HPName
        this.InvClassCode = data.CusCode
        this.TXCusName = data.TXCusName
        this.TXCusID = data.TXCusID
        this.HPid = data.ProviderID
        this.HospHPid = data.Hospital
        loading.close();
        this.dialogVisiblesedit = true
      }
      loading.close();
    },
    // 修改
    async APPRelationProviderEdit() {
      const loading = this.$loading({
        lock: true,
        text: '修改中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message
      } = await APPRelationProviderEdit({
        ID: this.ID,
        CusCode: this.$refs.DsphFEditref[1].modelvalue == this.InvClassCodeName ? this.InvClassCode : this.$refs.DsphFEditref[1].modelvalue,
        InvClass: this.$refs.DsphFEditref[0].modelvalue,
        ProviderID: this.$refs.DsphFEditref[3].modelvalue == this.HPidName ? this.HPid : this.$refs.DsphFEditref[3].modelvalue,
        // ProviderType: this.$refs.DsphFEditref[2].modelvalue,
        TXCusID: this.$refs.DsphFEditref[2].modelvalue == this.TXCusName ? this.TXCusID : this.$refs.DsphFEditref[2].modelvalue,
        Hospital: this.$refs.DsphFEditref[4].modelvalue == this.HospHPidName ? this.HospHPid : this.$refs.DsphFEditref[4].modelvalue,
        VouchValiDate: this.$refs.DsphFEditref[5].modelvalue,
        Remark: this.$refs.DsphFEditref[7].modelvalue,
        HasHPInvoice: this.$refs.DsphFEditref[6].radios,
        imageNames: this.FileName,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '修改成功'
        });
        this.rowboo == false
        loading.close();
        this.dialogVisiblesedit = false
        this.APPRelationProviderList()
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
      loading.close();
    },
    // 新增
    async APPRelationProviderAdd() {
      // console.log(this.$refs.DsphFAddref[7].radios,'this.$refs.DsphFAddref[7].radio');
      // return
      const loading = this.$loading({
        lock: true,
        text: '正在新增中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });

      let {
        code,
        message
      } = await APPRelationProviderAdd({
        CusCode: this.$refs.DsphFAddref[1].modelvalue,
        InvClass: this.$refs.DsphFAddref[0].modelvalue,
        ProviderID: this.$refs.DsphFAddref[3].modelvalue,
        // ProviderType: this.$refs.DsphFAddref[2].modelvalue, 
        TXCusID: this.$refs.DsphFAddref[2].modelvalue,
        Hospital: this.$refs.DsphFAddref[4].modelvalue,
        VouchValiDate: this.$refs.DsphFAddref[5].modelvalue,
        Remark: this.$refs.DsphFAddref[7].modelvalue,
        HasHPInvoice: this.$refs.DsphFAddref[6].radios,
        imageNames: this.FileName,
      })
      if (code == 0) {
        this.$message({
          type: 'success',
          message: '新增成功'
        });
        this.rowboo == false
        this.handleList.length = 0
        this.APPRelationProviderList()
        this.dialogVisibles = false
        this.$refs.DsphFAddref.map((item, index) => {
          item.modelvalue = ""
        })
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
      loading.close();
    },
    // 编辑上传照片
    async APPRelationProviderUploadImageByEdit(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        for (var i = 0; i < file.length; i++) {
          formData.append("files", file[i]);
        }
        let res = await APPRelationProviderUploadImageByEdit(formData)
        if (res.code == 0) {
          res.data.map((item, index) => {
            this.FileName.push(item.FileName)
            this.ImageUrl.push(item.ImageUrl)
          })
          //console.log(this.ImageUrl);
          this.$message({
            type: 'success',
            message: res.message
          })
          loading.close();
        } else if (res.code == 101) {
          this.$message({
            type: 'warning',
            message: res.message
          })
          loading.close();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        loading.close();
      }
    },
    getFileDsphImg(file) {
      this.APPRelationProviderUploadImageByEdit(file)
    },
    // 删除
    async APPRelationProviderDelete() {
      let arr = []
      this.handleList.map((item, index) => {
        arr.push(item.ID)
      })
      let {
        code,
        data,
        message
      } = await APPRelationProviderDelete({
        IDs: arr
      })
      if (code == 0) {
        this.$message({
          type: "success",
          message: "删除成功"
        })
        this.APPRelationProviderList()
        this.rowboo == false
        this.handleList.length = 0
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection()
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        })
      } else if (code == 2) {
        this.dialogVisiblesdrjg = true
        this.tableDatadrjg = data
        this.title = "删除结果"
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
    },
    // 启用
    async cusRelationProviderActive() {
      let arr = []
      this.handleList.map((item, index) => {
        arr.push(item.ID)
      })
      let {
        code,
        data,
        message
      } = await CusRelationProviderActive({
        IDs: arr
      })
      if (code == 0) {
        this.$message({
          type: "success",
          message: "启用成功"
        })
        this.APPRelationProviderList()
        this.rowboo == false
        this.handleList.length = 0
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection()
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        })
      } else if (code == 2) {
        this.dialogVisiblesdrjg = true
        this.tableDatadrjg = data
        this.title = "启用结果"
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
    },

    // 停用
    async cusRelationProviderDeActive() {
      let arr = []
      this.handleList.map((item, index) => {
        arr.push(item.ID)
      })
      let {
        code,
        data,
        message
      } = await CusRelationProviderDeActive({
        IDs: arr
      })
      if (code == 0) {
        this.$message({
          type: "success",
          message: "停用成功"
        })
        this.APPRelationProviderList()
        this.rowboo == false
        this.handleList.length = 0
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection()
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        })
      } else if (code == 2) {
        this.dialogVisiblesdrjg = true
        this.tableDatadrjg = data
        this.title = "停用结果"
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
    },

    async inventoryClassList() {
      let {
        code,
        data
      } = await InventoryClassList({
      })
      if (code == 0) {
        this.fromdataadd[0].options = []
        this.fromdataedit[0].options = []
        this.FromArr[1].options = []

        data.data.map((item, index) => {
          let obj = {
            key: item.InvClass,
            value: item.InvClassName
          }
          this.fromdataedit[0].options.push(obj)
          this.fromdataadd[0].options.push(obj)
          this.FromArr[1].options.push(obj)
        })
      }
    },
    // 导入
    async cusRelationProviderImport(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '导入中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        formData.append("file", file)
        let res = await CusRelationProviderImport(formData)
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: res.message
          })

          loading.close();
        } else if (res.code == 101) {
          this.$message({
            type: 'warning',
            message: res.message
          })
          loading.close();
        } else {
          this.dialogVisiblesdrjg = true
          this.tableDatadrjg = res.data
          this.title = "导入结果"
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        this.APPRelationProviderList()
        loading.close();
      }
    },
    InvoiceImport(file) {
      this.cusRelationProviderImport(file)
    },
    async cusRelationProviderDownloadTemplet() {
      // 测试
      // this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
      let {
        data,
        code,
        message
      } = await CusRelationProviderDownloadTemplet({})
      if (code == 0) {
        window.location.href = data
      } else if (code == 101) {
        this.$message({
          type: 'warning',
          message: message
        });
      } else {
        this.$message({
          type: 'error',
          message: message
        });
      }
    },

    // 提交
    async APPRelationProviderSubmit() {
      const loading = this.$loading({
        lock: true,
        text: '提交中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let arr = []
      this.handleList.map((item, index) => {
        arr.push(item.ID)
      })
      let {
        code,
        data,
        message
      } = await APPRelationProviderSubmit({
        IDs: arr
      })
      if (code == 0) {
        this.$message({
          type: "success",
          message: "提交成功"
        })
        this.APPRelationProviderList()
        // this.dialogVisiblesdrjg = true
        // this.tableDatadrjg = data
        // this.title = "提交结果"
        this.rowboo = false
        this.handleList.length = 0
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection()
        this.dialogVisibleSubmit = false
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        })
      } else if (code == 2) {
        this.dialogVisiblesdrjg = true
        this.tableDatadrjg = data
        this.title = "提交结果"
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
      loading.close()
    },
    //提交
    Submit() {
      if (this.handleList.length >= 1) {
        this.dialogVisibleSubmit = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要提交的数据(多选)！'
      });
    },
    cancelSubmit() {
      this.dialogVisibleSubmit = false
    },
    dialogOKSubmit() {
      this.APPRelationProviderSubmit()
    },

    // 撤回
    async APPRelationProviderRevoke() {
      const loading = this.$loading({
        lock: true,
        text: '撤回中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let arr = []
      this.handleList.map((item, index) => {
        arr.push(item.ID)
      })
      let {
        code,
        data,
        message
      } = await APPRelationProviderRevoke({
        IDs: arr
      })
      if (code == 0) {
        this.$message({
          type: "success",
          message: "撤回成功"
        })
        this.APPRelationProviderList()
        // this.dialogVisiblesdrjg = true
        // this.tableDatadrjg = data
        // this.title = "撤回结果"
        this.rowboo = false
        this.handleList.length = 0
        this.$refs.ProviderRef.$refs.fileTableSelect.clearSelection()
        this.dialogVisiblewithdraw = false
      } else if (code == 101) {
        this.$message({
          type: "warning",
          message: message
        })
      } else if (code == 2) {
        this.dialogVisiblesdrjg = true
        this.tableDatadrjg = data
        this.title = "撤回结果"
      } else {
        this.$message({
          type: "error",
          message: message
        })
      }
      loading.close()
    },
    // 撤回
    withdraw() {
      if (this.handleList.length >= 1) {
        this.dialogVisiblewithdraw = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要撤回的数据(多选)！'
      });
    },
    cancelwithdraw() {
      this.dialogVisiblewithdraw = false
    },
    dialogOKwithdraw() {
      this.APPRelationProviderRevoke()
    },
    DsphfDowload() {
      this.cusRelationProviderDownloadTemplet()
    },
    async hospital(val) {
      let {
        code,
        data
      } = await HospitalList({
        HosType: "采购代理",
        HPName: val,
      })
      if (code == 0) {
        this.HPid = data.data[0].HPID
      }
    },
    async hospitalHP(val) {
      let {
        code,
        data
      } = await HospitalList({
        HosType: "医院",
        HPName: val,
      })
      if (code == 0) {
        this.HospHPid = data.data[0].HPID
      }
    },

    JXSUPChage(e) {
      this.HospitalInfoJSXUP(e.modelvalue)
      //console.log(e, 'e');
    },
    JXSChage(e) {
      this.HospitalInfoJSX(e.modelvalue)
      //console.log(e);
    },
    async HospitalInfoJSXUP(val) {
      let {
        code,
        data
      } = await HospitalInfo({
        hpid: val,
      })
      if (code == 0) {
        this.$refs.DsphFEditref[2].modelvalue = data.HosType
      }
    },
    async HospitalInfoJSX(val) {
      let {
        code,
        data
      } = await HospitalInfo({
        hpid: val,
      })
      if (code == 0) {
        this.$refs.DsphFAddref[2].modelvalue = data.HosType
      }
    },
    async remoteHosType(query) {
      this.loading = true
      let {
        code,
        data
      } = await HospitalList({
        // HosType: "经销商",
        IsTXCus: 1,
        HPName: query
      })
      if (code == 0) {
        this.fromdataadd[2].options = []
        this.fromdataedit[2].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.HPID,
            value: item.HPName
          }
          this.fromdataadd[2].options.push(obj)
          this.fromdataedit[2].options.push(obj)
        })
        this.loading = false
      }
    },
    async remoteMethodtowHB(query) {
      this.loading = true
      let {
        code,
        data
      } = await HospitalList({
        HosType: "采购代理",
        HPName: query,
      })
      if (code == 0) {
        this.fromdataadd[3].options = []
        this.fromdataedit[3].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.HPID,
            value: item.HPName
          }
          this.fromdataadd[3].options.push(obj)
          this.fromdataedit[3].options.push(obj)
        })
        this.loading = false
      }
    },
    // 医院下拉
    async remoteMethodtows(query) {
      this.loading = true
      let {
        code,
        data
      } = await HospitalList({
        HosType: "医院",
        HPName: query
      })
      if (code == 0) {
        this.fromdataadd[4].options = []
        this.fromdataedit[4].options = []
        data.data.map((item, index) => {
          let obj = {
            key: item.HPID,
            value: item.HPName
          }
          this.fromdataadd[4].options.push(obj)
          this.fromdataedit[4].options.push(obj)
        })
        this.loading = false
      }
    },
    // 上传照片(多选)
    async UploadPhotos(file) {
      if (this.rowboo == true) {
        const loading = this.$loading({
          lock: true,
          text: '正在上传...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formdata = new FormData()
        for (var i = 0; i < file.length; i++) {
          formdata.append("files", file[i]);
        }
        let {
          data,
          code,
          message
        } = await CusRelationProviderUploadSalesInvListPic(formdata, this.ID)
        if (code == 0) {
          this.$message({
            type: 'success',
            message: message
          });
          loading.close();
          // this.rowboo = false
          this.APPRelationProviderList()
          return
        } else if (code == 101) {
          this.$message({
            type: 'warning',
            message: message
          });
          loading.close();
          return
        } else {
          this.dialogVisiblesdrjg = true
          this.tableDatadrjg = data
          this.title = "上传结果"
          this.$message({
            type: 'error',
            message: message
          });
          loading.close();
        }
      }

      this.$message({
        type: "error",
        message: "请选择要操作的数据！"
      })

    },
    onRowClick(val) {
      this.ID = val.ID
      this.rowboo = true
      console.log(val);
      if (val.Status == 0 || val.Status == 15) {
        this.AddOptional = false
        this.updateOptional = false
        this.DelOptional = false
        this.SubmitOptional = false
      } else {
         this.AddOptional = true
        this.updateOptional = true
        this.DelOptional = true
        this.SubmitOptional = true
      }
      if(val.Status == 20){
        this.WithdrawOptional = false
      } else {
        this.WithdrawOptional = true
      }
    },
    adduser() {
      this.dialogVisibles = true
      this.hospitalGetHospitalType()
      this.inventoryClassList()
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      this.APPRelationProviderAdd()

    },
    update() {
      console.log(this.rowboo, 'rowboo');
      if (this.rowboo == true) {
        this.APPRelationProviderInfo()
        this.hospitalGetHospitalType()
        this.inventoryClassList()
        this.stateDelIcon = 'update'
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要修改的数据！'
      });
    },
    canceledit() {
      this.dialogVisiblesedit = false
    },
    dialogOKedit() {
      this.APPRelationProviderEdit()

    },
    del() {
      if (this.handleList.length >= 1) {
        this.dialogVisibledel = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要删除的数据(多选)！'
      });

    },
    canceldel() {
      this.dialogVisibledel = false
    },
    dialogOKdel() {
      this.APPRelationProviderDelete()
      this.dialogVisibledel = false
    },
    Active() {
      if (this.handleList.length >= 1) {
        this.dialogVisibledeactivate = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要启用的数据(多选)！'
      });
    },
    canceldeactivate() {
      this.dialogVisibledeactivate = false
    },
    dialogOKdeactivate() {
      this.cusRelationProviderActive()
      this.dialogVisibledeactivate = false
    },

    downs(index) {
      // //console.log("index", index)
      if (index == 0) {
        this.dialogVisiblesU8 = true
      }
      if (index == 1) {
        this.dialogVisiblesU8d = true
      }
    },
    DeActive() {
      if (this.handleList.length >= 1) {
        this.dialogVisibledeactivateDe = true
        return
      }
      this.$message({
        type: 'error',
        message: '请选择要停用的数据(多选)！'
      });
    },
    canceldeactivateDe() {
      this.dialogVisibledeactivateDe = false
    },
    dialogOKdeactivateDe() {
      this.cusRelationProviderDeActive()
      this.dialogVisibledeactivateDe = false
    },

    handleSelectionChange(val) {
      this.handleList = val
    },
    canceldrjg() {
      this.dialogVisiblesdrjg = false
    },
    dialogOKdrjg() {
      this.dialogVisiblesdrjg = false
    },

    showclick() {

    },
    hide() {

    },
    select() {
      this.pageindex = 1
      this.from.CusName = this.FromArr[0].modelvalue
      this.from.InvClass = this.FromArr[1].modelvalue
      this.from.ProviderName = this.FromArr[2].modelvalue
      this.from.TXCusName = this.FromArr[3].modelvalue
      this.from.HPName = this.FromArr[4].modelvalue
      this.from.HasHPInvoice = this.FromArr[5].modelvalue
      this.from.ActiveTime1 = this.FromArr[6].StartTime
      this.from.ActiveTime2 = this.FromArr[6].EndTime
      this.from.CreateTime1 = this.FromArr[7].StartTime
      this.from.CreateTime2 = this.FromArr[7].EndTime
      this.APPRelationProviderList()

    },
    reset() {
      this.FromArr.map((item, index) => {
        if (index == 6 || index == 7) {
          item.StartTime = '';
          item.EndTime = '';
        }
        item.modelvalue = '';
      })
    },
    handleCurrentChange(PageIndex) {
      this.pageindex = PageIndex
      this.APPRelationProviderList()
    },
    handleSizeChange(PageSize) {
      this.pageSize = PageSize
      this.APPRelationProviderList()
    },
  },
  computed: {},
  watch: {
    dialogVisibles: {
      handler(newVal, oldVal) {
        if (newVal == false) {
          //console.log(newVal);
          this.ImageUrl = []
          this.FileName = []
          this.TXCusName = ''
          this.TXCusID = ''
        }
      }
    },
    dialogVisiblesedit: {
      handler(newVal, oldVal) {
        if (newVal == false) {
          this.ImageUrl = []
          this.FileName = []
          this.TXCusName = ''
          this.TXCusID = ''
        }
      }
    },
    $route: {
      handler(to , from){
       let data = JSON.parse(localStorage.getItem("MenusData"))
       data.CusWebMenus.forEach((item , index) => {
         if(item.NodeID == 61){
           item.Nodes.forEach((items , indexs) => {
             if(items.NodeID == to.query.NodeID){
               items.Nodes.forEach((itemes , indexes) => {
                 if(itemes.NodeID == to.query.MenuID){
                   this.qus = itemes.Buttons
                 }
               })
             }
           })
         }
       });
       console.log(this.qus,'qus');
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          } else if (item.NodeName == 'skip') {
            this.qx.skip = true
          } else if (item.NodeName == 'reset') {
            this.qx.reset = true
          } else if (item.NodeName == 'setting') {
            this.qx.setting = true
          } else if (item.NodeName == 'submit') {
            this.qx.submit   = true
          }
        })
      }
      },
      deep: true,
      immediate: true
    }
    /**
     * 
     */
  },
}
</script>
<style scoped lang='less'>
.ProviderRecord {
  width: 100%;
  height: 100%;
  position: relative;
  .TopSearch {
    margin: 1px 13px;
    width: 920px;
    height: 300px;
    // border: 1px solid #e5e7ea;
    // padding-bottom: 10px;
    box-shadow: 0px 1px 4px 1px #e5e7ea;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .btngroup {
      // border: 1px solid #0b65ec;
      position: relative;
      bottom: 10px;
    }
  }
  .BottomTable {
    margin: 32px 13px;
    padding: 10px;
    width: 900px;
    // height: 518px;
    // border: 1px solid #e5e7ea;
    box-shadow: 0px 1px 4px 2px #e5e7ea;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
// .uploadImg {
//   // width: 800px;
//   padding-left: 25px;
//   // border: 1px solid red;
// }
.DelOrSee {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-color: #000;
  opacity: 0.2;
  position: relative;
  margin-left: -120px;
}
.del_icon {
  position: relative;
  left: 80px;
  top: -50px;
  z-index: 99;
  cursor: pointer;
}
.See_icon {
  position: relative;
  left: 110px;
  top: -50px;
  z-index: 99;
  cursor: pointer;
}
.imgBJ {
  width: 120px;
  height: 120px;
  position: relative;
  // top: 38px;
  margin-left: 20px;
  border: 1px solid #c1c5ca;
}
.uploadImg {
  // width: 800px;
  padding-left: 25px;
  // border: 1px solid red;
}
.DelOrSee {
  width: 120px;
  height: 120px;
  display: inline-block;
  background-color: #000;
  opacity: 0.2;
  position: relative;
  margin-left: -120px;
}
</style>